
export default {
  container: {
    boxShadow: '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)',
    borderRadius: '5px',
    padding: 0,
    backgroundColor: '#c7c7c7',
  },
  title: {
    padding: '20px 16px'
  },
  list: {
    padding: '8px 0'
  },
  listItem: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '8px 16px',
  },
  textBox: {
    width: '90%',
  },
  text: {
    fontSize: 14,
  },
  chip: {
    margin: '3px',
    color: '#fff',
  },
  link: {
    textDecoration: 'none',
  },
  gridContainer: {
    marginBottom: 5
  },
}
